import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://jculsvgvetkdockclekk.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImpjdWxzdmd2ZXRrZG9ja2NsZWtrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjUxNjQ2ODAsImV4cCI6MjA4MDc0MDY4MH0.QNoMn0yR-gGkj6IH1tMRo_4T4ndg6rJTQyVyyv_1p8U'

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Import the supabase client like this:
// For React:
// import { supabase } from "@/integrations/supabase/client";
// For React Native:
// import { supabase } from "@/src/integrations/supabase/client";
